import { render, staticRenderFns } from "./BalanceTransDetails.vue?vue&type=template&id=1b81e43c&scoped=true"
import script from "./BalanceTransDetails.vue?vue&type=script&lang=js"
export * from "./BalanceTransDetails.vue?vue&type=script&lang=js"
import style0 from "./BalanceTransDetails.vue?vue&type=style&index=0&id=1b81e43c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b81e43c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b81e43c')) {
      api.createRecord('1b81e43c', component.options)
    } else {
      api.reload('1b81e43c', component.options)
    }
    module.hot.accept("./BalanceTransDetails.vue?vue&type=template&id=1b81e43c&scoped=true", function () {
      api.rerender('1b81e43c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/Balance/BalanceTransDetails.vue"
export default component.exports